import { render, staticRenderFns } from "./BitacoraBase.vue?vue&type=template&id=1c99a929&"
import script from "./BitacoraBase.vue?vue&type=script&lang=ts&"
export * from "./BitacoraBase.vue?vue&type=script&lang=ts&"
import style0 from "./BitacoraBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports